import React from "react";
import {Accordion, Spinner, Alert, Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser, faTableColumns, faArrowRotateRight} from "@fortawesome/free-solid-svg-icons";
import UserCard from "../Cards/UserCard";
import Badge from "react-bootstrap/Badge";

function UserInfo({userData, isLoading, error, bondsData = {}, bonds, selectedHomeId = null, onToggleLayout = null, currentLayoutLabel = '', onRefresh = null}) {
    if (isLoading && !userData) {
        return (
            <div className="pe-2 p-3 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="pe-2 p-3">
                <Alert variant="danger">
                    Error loading user data: {error}
                </Alert>
            </div>
        );
    }

    if (!userData) {
        return null;
    }

    return (
        <div>
            {onToggleLayout && (
                <Button
                    variant="outline-secondary"
                    onClick={onToggleLayout}
                    title={`Current layout: ${currentLayoutLabel}. Click to toggle.`}
                    className="w-100 p-1 mb-0"
                    style={{height: '14px', border: 'none', borderRadius: '6px'}}
                >
                </Button>
            )}
            <Accordion defaultActiveKey={["User"]} className="sidebarAccordion mb-2" alwaysOpen>
                <Accordion.Item eventKey="User">
                    <Accordion.Header>
                        <div className="d-flex justify-content-between align-items-center w-100 me-2">
                            <div>
                                <FontAwesomeIcon icon={faUser} className="me-2"/>User Account
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Badge className="integrationBadge" style={{'--integration-badge-bg': '#8da9c4', '--integration-badge-color': '#1c2b3a'}}>
                                    <FontAwesomeIcon icon={faUser} className="me-1" size="xs"/>{userData.email}
                                </Badge>
                                {onRefresh && (
                                    <button
                                        className="btn btn-sm p-0"
                                        style={{color: 'inherit', background: 'none', border: 'none', opacity: isLoading ? 0.5 : 0.7, lineHeight: 1}}
                                        onClick={(e) => { e.stopPropagation(); onRefresh(); }}
                                        disabled={isLoading}
                                        title="Refresh user data and bonds"
                                    >
                                        <FontAwesomeIcon icon={faArrowRotateRight} size="sm" className={isLoading ? 'fa-spin' : ''} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body className="p-0">
                        <UserCard userData={userData} bondsData={bondsData} bonds={bonds} selectedHomeId={selectedHomeId}/>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
}

export default UserInfo;
